import * as UserActions from '../state/user/user.actions';
import { removeLoadingScreenAfterDelay } from '../functions/app.functions';
import { userIsGroupAdmin } from '../functions/user.functions';
import App from '../app';

export default function AppController(
  initialData,
  $scope,
  $rootScope,
  usersService,
  $state,
  navService,
  $window,
  $location,
  appNotificationsService,
  $uibModal,
  languagesService, // /* :O THREE MANY INJEX */
  $ngRedux,
) {
  'ngInject';
  let vm = this;
  $scope.show = {};
  $scope.show.singleSignOnFlag = true;

  vm.$onInit = () => {
    vm.unsubscribe = $ngRedux.connect(vm.mapStateToThis, UserActions)(vm);

    removeLoadingScreenAfterDelay();

    // GTM TESTING\
    // ----- FIGURE OUT IF .master IS POPULATED AT THIS POINT OR IF THIS WILL ALWAYS DEFAULT TO USE ACCOUNT.NAME
    // const master = $rootScope.currentUser.master || $rootScope.currentUser.account.name;
    const master = $rootScope.currentUser.master;

    window.dataLayer = window.dataLayer || [];

    // Identifying user information on amplitude
    try {
      const { id: userId, account: {
        name : accountName,
        id: accountId
      } } = $rootScope.currentUser;

      const identifyEvent = new App.amplitude.Identify();
      identifyEvent.setOnce('Customer Id', accountId);
      identifyEvent.setOnce('Account Name', accountName);

      App.amplitude.setUserId(userId)
      App.amplitude.identify(identifyEvent);
    }
    catch (e) {
      console.log(e);
    }

    window.dataLayer.push({
      userId: $rootScope.currentUser.id,
      account: $rootScope.currentUser.account.name,
      accountId: $rootScope.currentUser.account.id.toString(),
      org: master,
    });
  };

  vm.$onDestroy = () => {
    vm.unsubscribe();
  };

  vm.mapStateToThis = (state) => {
    const { user } = state;
    const { app } = state;
    $rootScope.datapointDescriptors = user.datapointDescriptors;
    let descriptorsByKey = {};
    user.datapointDescriptors?.forEach((desc) => {
      if (desc.key) {
        let key = desc.key.split('.').sort().join('.');
        descriptorsByKey[key] = desc;
      }
    });
    $rootScope.datapointDescriptorsByKey = descriptorsByKey;

    $scope.accountId = user.account.id;
    $scope.brandLogo = app.logoUrl;
    $scope.mobileUrl = app.cornerIcon;



    return {};
  };

  $rootScope.$on('$stateChangeStart', (event, toState) => {
    if (!toState.requiredDatapoints || !$rootScope.currentUser) {
      return;
    }

    let mapRequired = false;

    for (let i = 0; i < toState.requiredDatapoints.length; i++) {
      if (toState.requiredDatapoints[i] === 'gps') {
        mapRequired = true;
        break;
      }
    }

    if (!mapRequired) {
      return; // no need to redirect
    }

    //perform redirect if user is unauthorized to see map

    let mapAccessible = false;
    for (let j = 0; j < $rootScope.currentUser.visibleDatapoints.length; j++) {
      if ($rootScope.currentUser.visibleDatapoints[j].id === 'gps') {
        mapAccessible = true;
      }
    }

    if (!mapAccessible) {
      event.preventDefault(); // stop current execution
      $state.go('equipment'); // go to asset list
    }
  });

  //track views of individual site pages via Google Analytics
  $rootScope.$on('$stateChangeSuccess', () => {
    // GTM TESTING
    window.dataLayer.push({
      event: 'ngRouteChange',
      attributes: {
        route: $location.path(),
      },
    });
  });

  // Determine appropriate navigation items.
  let calculateNavItems = () => {
    $rootScope.navItems = [];

    let modules = navService.getModules();

    for (let key in modules) {
      let module = modules[key];

      if (module.hide) {
        continue;
      }

      //filter out invalid items
      module.items = (module.items || []).filter((item) => navService.isValidState(item.sref));

      //add the module if root state is valid or one of it's sub item valid
      if (navService.isValidState(module.sref) || module.items.length > 0) {
        $rootScope.navItems.push(module);
      }
    }

    $rootScope.navItems.sort((a, b) => {
      return b.priority - a.priority;
    });
  };

  $rootScope.currentUser = usersService.currentUser();

  try {
    let lng = $rootScope.currentUser.claims.data.language;

    //temporary  , in case the user has set his language (english, french) befor changing to en, fr..
    if (lng === 'english' || lng === 'french') {
      lng = 'en';
      $rootScope.currentUser.claims.data.language = 'en'; // for help section
    }
    // set the app language
    languagesService.setCurrentLanguage(lng);
  } catch (ex) {
    languagesService.setCurrentLanguage();
  }

  if (!$rootScope.currentUser.changeEmail) {
    $scope.show.singleSignOnFlag = false;
  }

  calculateNavItems();
  //Set the modules on the page to be used everywhere!
  $rootScope.isShowingSideNav = () => {
    return navService.isShowingSideNav();
  };

  $scope.openNotificationModal = (_activeNotification) => {
    let modalInstance = $uibModal.open({
      template: require('../pages/app-notifications/app.notifications.modal.html'),
      controller: 'AppNotificationsController',
      resolve: {
        notification: () => {
          return _activeNotification;
        },
      },
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    });

    modalInstance.result.then((updatedAccepted) => {
      // post  Active Notifications to acknowldege
      appNotificationsService.acknowledgeNotications(updatedAccepted).then(null, (error) => {
        let errorMsg = 'An error occurred while acknowledge app notifications';

        if (error.data || error.status) {
          if (error.data) {
            errorMsg = `${error.data} ${error.status.toString()} - ${error.statusText.toString()}`;
          } else {
            errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
          }
        }

        return errorMsg;
      });
    });
  }; // end openNotificationModal

  if (initialData.activeNotifications && initialData.activeNotifications.length > 0) {
    $scope.openNotificationModal(initialData.activeNotifications);
  }

  //for redirecting to specific section on the help page
  $scope.goHelp = () => {
    //help variables for page selection
    let helpPage = '';
    let helpItem = '';

    //current state and parent state variable
    let currentState = $state.current.name;
    currentState = currentState.replace(/[0-9]/gi, '');

    let helpModuleId = $state.current.helpModuleId;
    let helpState = $state.current.helpState;

    //set the help variables for page section
    if (currentState === 'help') {
      //if help button is clicked from same page
      currentState = $location.path();
      let page = currentState.split('/');
      helpPage = page[2] || null;
      helpItem = page[3] || null;
    } // help clicked from other page on website
    else {
      let page = currentState.split('.');
      helpPage = page[0];

      currentState = currentState.replace(/[-.]/gi, '');
      helpItem = currentState;
      if (helpState) {
        // if parent state available
        //remove integer and . from patent state to create id of the div
        helpState = helpState.replace(/[-.0-9]/gi, '');
        helpItem = helpState;
      }

      if (helpModuleId) {
        helpPage = helpModuleId;
      }
    }

    //convert to lowercase
    if (helpItem) helpItem = helpItem.toLowerCase();
    if (helpPage) helpPage = helpPage.toLowerCase();

    $state.go('help', {
      helpPage: helpPage,
      helpItem: helpItem,
    });
  };
}
